<template>
    <BaseModal :id="`${modal_id}`" :title="title" :message="message" :size="'md'">
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb" />
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="hideModal()">
                <div>
                    <div class="text-center w-100" style="height: 3rem !important;" v-if="is_loading_images">
                        <div class="spinner-border mt-2" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else-if="inspection_room_images.length">
                        <div v-for="(saved_image, index) in inspection_room_images" :key="index">
                            <div v-if="index_active === index" >
                                <a style="top: -150px; cursor: auto;" class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev"> 
                                    <span style="cursor: pointer;" class="carousel-control-prev-icon" aria-hidden="true" @click="$emit('previousImage')"></span>
                                    <span class="sr-only">Previous</span>
                                </a>
                                <img :src="saved_image.url" class="d-block w-100" alt="Image" :id="index" style="height: 500px;">
                                <div class="carousel-caption d-none d-md-block mt-2" style="position: static; padding-top: 0px; padding-bottom: 0px;" v-if="hasPermissions(['QC-Inspection Upload Room Images'])">
                                    <button type="button" class="modal__buttons__item cancel" style="width: 4rem;" @click="removeRoomImage(saved_image.id, index)">
                                        Remove
                                    </button>
                                </div>
                                <a style="top: -150px; cursor: auto;" class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next" >
                                    <span style="cursor: pointer;" class="carousel-control-next-icon" aria-hidden="true" @click="$emit('nextImage')"></span>
                                    <span class="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-primary" role="alert" v-else>
                        No images found for this room.
                    </div>
                </div>
                <CentralLiteButtons :save_text="'Done'"/>
            </form>
        </template>
    </BaseModal>
</template>

<script>
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal from '@/components/BaseModal'
import CentralLiteButtons from '@/components/CentralLiteButtons';

export default {

    name: 'InspectionRoomImagesModal',

    props: [
        'breadcrumb',
        'inspection_room_images',
        'is_loading_images',
        'index_active'
    ],

    components: {
        Breadcrumb,
        BaseModal,
        CentralLiteButtons
    },

    data() {
        return {
            title: "Inspection Room Images",
            modal_id: 'static-inspection-room-images',
            message: undefined
        }
    },

    mounted() {},

    methods: {

        hideModal()
        {
            window.$('#static-inspection-room-images').modal('hide')
        },
        
        removeRoomImage(id, index)
        {
            this.$emit('removeRoomImage', {id, index})
        }
    },

}
</script>

<style lang="css">
.carousel-control-next-icon, .carousel-control-prev-icon
{
    width: 80px !important;
    height: 35px !important;
}
</style>
